module.exports = __webpack_public_path__ + "static/media/pills.9e2c4786.svg";